import Konva from 'konva';
import GraphicBase from '../../roadMapComponent/graphics/base';

const normal = '#67C23A';
const padding = '#FFA920';
const going = '#0A7CFF';
const fail = '#FF4D4F';
const colors = { normal, padding, going, fail };
class GraphicPanoramaPoint extends GraphicBase {
  constructor(payload, stage) {
    super(payload, stage);

    this.canDraggable = false;
  }

  build() {
    const { data, id, stage, property } = this;

    const p = stage.pointDict[data[0]];
    if (!p) return;
    this.ele = new Konva.Circle({
      id,
      pid: data[0],
      x: p.x,
      y: p.y,
      isPoint: true,
      radius: 30,
      opacity: 0.4,
      fill: colors[property.state] || normal,
    });
    this.ele.on('click', (e) => {
      if (stage.viewType !== 1) {
        if (stage.userState) return;
      }
      this.select();
      stage.pointClickHandler(e);
    });

    stage.pointLayer.add(this.ele);
    this.layer = stage.pointLayer;
    this.ele.__proto__.select = this.select;
    return this.ele;
  }

  select() {
    const { data, stage, property } = this;
    const p = stage.pointDict[data[0]];
    if (!p) return;
    stage.randertmpLayer();
    const e1 = new Konva.Circle({
      pid: data[0],
      x: p.x,
      y: p.y,
      isPoint: true,
      radius: 30,
      fill: colors[property.state] || normal,
    });
    const e2 = new Konva.Circle({
      pid: data[0],
      x: p.x,
      y: p.y,
      isPoint: true,
      radius: 40,
      stroke: colors[property.state] || normal,
    });
    stage.tmpLayer.add(e1);
    stage.tmpLayer.add(e2);
  }

  updateState() {
    const { property } = this;
    this.ele.fill(colors[property.state]);
    this.select();
  }
}

export default GraphicPanoramaPoint;
